import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAtsignGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M6.098 6.098C4.78 7.416 4 9.388 4 12s.78 4.584 2.098 5.902S9.388 20 12 20c1.15 0 2.178-.152 3.077-.433a1 1 0 0 1 .596 1.909C14.556 21.825 13.326 22 12 22c-3.013 0-5.54-.908-7.316-2.683C2.908 17.54 2 15.013 2 12s.908-5.54 2.684-7.316C6.459 2.908 8.987 2 12 2s5.54.908 7.317 2.684C21.092 6.459 22 8.987 22 12c0 1.845-.462 3.24-1.311 4.185-.859.953-1.995 1.315-3.064 1.315a1 1 0 1 1 0-2c.619 0 1.17-.2 1.577-.653.416-.463.798-1.317.798-2.847 0-2.612-.78-4.584-2.098-5.902S14.612 4 12 4s-4.584.78-5.902 2.098'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='m16.575 9.871.003-.036.175-1.669a1 1 0 0 0-1.73-.782c-1.174-.933-2.698-1.21-4.113-.89-2.143.485-4.033 2.321-4.308 5.162-.273 2.832.888 5.04 2.952 5.861 1.703.678 3.719.289 5.509-1.067q.23.261.523.466c.594.413 1.303.584 2.039.584a1 1 0 1 0 0-2c-.433 0-.715-.1-.897-.226-.173-.12-.333-.318-.434-.67-.093-.322-.134-.772-.07-1.375zm-2.017.05c-.67-1.306-1.964-1.758-3.206-1.477-1.31.297-2.568 1.43-2.76 3.404-.212 2.204.682 3.405 1.702 3.811.977.39 2.453.207 3.949-1.12a6.3 6.3 0 0 1-.01-1.518z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAtsignGhostLine)
export default ForwardRef
